export class MatrixUtil {
  static createMatrix<T>(x: number) {
    const xAxis: T[][] = [];
    for (let xi: number = 0; xi < x; xi++) {
      xAxis[xi] = [];
    }
    return xAxis;
  }
}
